import requestApi from "../../../api/fetchApi";
import { CreateOrUpdateEquipmentsInterface, EquipmentsInterface } from "../schemas/equipments";


export async function getProjectEquipments(projectId: string | number): Promise<EquipmentsInterface[]> {
    return requestApi.GET(`/api/projects/${projectId}/equipments`);
}


export async function createProjectEquipment(projectId: string | number, equipment: CreateOrUpdateEquipmentsInterface): Promise<EquipmentsInterface> {
    return requestApi.POST(`/api/projects/${projectId}/equipments`, {body: equipment});
}


export async function updateProjectEquipment(projectId: string | number, equipment: CreateOrUpdateEquipmentsInterface): Promise<EquipmentsInterface> {
    return requestApi.PUT(`/api/projects/${projectId}/equipments`, {body: equipment});
}

export async function deleteProjectEquipment(projectId: string | number, equipmentId: number | string): Promise<void> {
    return requestApi.DELETE(`/api/projects/${projectId}/equipments/${equipmentId}`);
}


export async function deleteUnrelatedEquipments(projectId: string | number): Promise<number[]> {
    return requestApi.DELETE(`/api/projects/${projectId}/equipments/unrelated`)
        .then((data) => {
            return data.deleted_rows;
        });
}
